import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactElement;
  roleRequired?: string; // ex: "admin"
}

const PrivateRoute = ({ children, roleRequired }: PrivateRouteProps) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // Nu există token, redirecționăm la login user
    return <Navigate to="/auth" replace />;
  }

  try {
    // Decodăm payload-ul JWT simplu (fără pachet extern)
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));
    const exp = decodedPayload.exp;
    const role = decodedPayload.role;

    // Verificăm dacă tokenul este expirat
    if (Date.now() >= exp * 1000) {
      localStorage.removeItem('token'); // ștergem tokenul expirat
      return <Navigate to="/auth" replace />;
    }

    // Dacă cerem un rol anume, îl verificăm
    if (roleRequired && role !== roleRequired) {
      // Nu are rolul necesar, redirect la home
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    // Token invalid sau neparseabil
    localStorage.removeItem('token');
    return <Navigate to="/auth" replace />;
  }

  // Token valid și cu rol corect (dacă era nevoie)
  return children;
};

export default PrivateRoute;
